import styled from 'styled-components';

export const AvatarPic = styled.img`
  border-radius: 50%;
  height: 32px;
  width: 32px;
`;

export const ContentTitle = styled.div`
  justify-content: flex-start !important;
  > img {
    margin-right: 16px;
  }
`;

export const ContentInfo = styled.div`
  justify-content: flex-start !important;
  flex-wrap: nowrap !important;

  > img {
    margin-right: 16px;
  }
  > div {
    display: flex;
    flex-direction: column;
    > p {
      margin-bottom: 4px;
      margin-top: 0;
    }
  }
`;

export const DisplayEmail = styled.span<{ isControlParental?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  color: #666666;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;

  @media (max-width: 650px) {
    width: 67vw;
  }

  @media (max-width: 450px) {
    width: 59vw;
  }

  ${({ isControlParental }) =>
    isControlParental &&
    `
      width: 18.5rem;

      @media (max-width: 650px) {
        width: 58vw;
      }

      @media (max-width: 379px) {
        width: 50vw;
      }
  `}
`;
